/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Id_Document_Already_On_File_UInputs */

const en_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID document already on file. Upload a new one below to replace it.`)
};

const es_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento de identidad ya archivado. Sube uno nuevo a continuación para reemplazarlo.`)
};

const fr_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document d'identité déjà enregistré. Téléchargez-en un nouveau ci-dessous pour le remplacer.`)
};

const de_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausweisdokument bereits hinterlegt. Lade unten ein neues hoch, um es zu ersetzen.`)
};

const ja_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身分証明書はすでに提出済みです。置き換える場合は以下から新しいものをアップロードしてください。`)
};

const zh_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已存有身份证件。您可以在下方上传新文件进行替换。`)
};

const ar_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وثيقة الهوية موجودة بالفعل في الملف. قم بتحميل واحدة جديدة أدناه لاستبدالها.`)
};

const id_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen identitas sudah ada dalam sistem. Unggah dokumen baru di bawah ini untuk menggantinya.`)
};

const it_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento di identità già in archivio. Caricane uno nuovo qui sotto per sostituirlo.`)
};

const ru_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документ, удостоверяющий личность, уже загружен. Загрузите новый ниже, чтобы заменить его.`)
};

const pt_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento de identidade já arquivado. Faça o upload de um novo abaixo para substituí-lo.`)
};

const ko_id_document_already_on_file_u = /** @type {(inputs: Id_Document_Already_On_File_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신분증 문서가 이미 등록되어 있습니다. 교체하려면 아래에 새 문서를 업로드하세요.`)
};

/**
* | output |
* | --- |
* | "ID document already on file. Upload a new one below to replace it." |
*
* @param {Id_Document_Already_On_File_UInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const id_document_already_on_file_u = /** @type {((inputs?: Id_Document_Already_On_File_UInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Id_Document_Already_On_File_UInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_id_document_already_on_file_u(inputs)
	if (locale === "es") return es_id_document_already_on_file_u(inputs)
	if (locale === "fr") return fr_id_document_already_on_file_u(inputs)
	if (locale === "de") return de_id_document_already_on_file_u(inputs)
	if (locale === "ja") return ja_id_document_already_on_file_u(inputs)
	if (locale === "zh") return zh_id_document_already_on_file_u(inputs)
	if (locale === "ar") return ar_id_document_already_on_file_u(inputs)
	if (locale === "id") return id_id_document_already_on_file_u(inputs)
	if (locale === "it") return it_id_document_already_on_file_u(inputs)
	if (locale === "ru") return ru_id_document_already_on_file_u(inputs)
	if (locale === "pt") return pt_id_document_already_on_file_u(inputs)
	return ko_id_document_already_on_file_u(inputs)
});